import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class LoaderService {
  public showLoader: BehaviorSubject<boolean>;
  constructor() {
    this.showLoader = new BehaviorSubject(false);
  }

  setLoaderStatus(inFlight: boolean) {
    if (inFlight != this.showLoader.value) {
      this.showLoader.next(inFlight);
    }
  }

  // getHttpStatus(): Observable<boolean> {
  //  return this.requestInFlight$.asObservable();
  // }
}

// @Injectable()
// export class HTTPListener implements HttpInterceptor {
//  constructor(private status: HTTPStatus) { }

//  intercept(
//    req: HttpRequest<any>,
//    next: HttpHandler
//  ): Observable<HttpEvent<any>> {
//    this.status.setHttpStatus(true);
//    return next.handle(req).pipe(
//      map(event => {
//        return event;
//      }),
//      catchError(error => {
//        return Observable.throw(error);
//      }),
//      finalize(() => {
//        this.status.setHttpStatus(false);
//      })
//    )
//  }
// }
